"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const putPersistentData = graphql_tag_1.default `
  mutation($environmentId: String!, $key: String!, $value: String!, $agentId: String) {
    putPersistentData(environmentId: $environmentId, key: $key, value: $value, agentId: $agentId, type: "WRITE") {
      environmentId
      key
      value
      agentId
      type
    }
  }
`;
exports.default = putPersistentData;
//# sourceMappingURL=putPersistentData.js.map